@if (isLoading()) {
  <app-spinner></app-spinner>
} @else {
  <np-header
    [sitename]="'Amended Return'"
    [welcomeMessage]="welcomeMessage"
    [menuItems]="navigationItems"
    [hasEnterpriseSearch]="false"
  >
  </np-header>
  @if (isUnauthorizedUser() === false) {
    <np-nav [navItems]="navigationItems"></np-nav>
  }

  <div class="logout" (click)="signOut()">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#0b2d71"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <title>Logout</title>
      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
      <polyline points="16 17 21 12 16 7" />
      <line x1="21" y1="12" x2="9" y2="12" />
    </svg>
  </div>

  <app-spinner></app-spinner>

  <!-- ROUTER-OUTLET -->
  <router-outlet></router-outlet>
  <!-- AUDIT_TRAIL MODAL  -->
  <app-audit-trail-modal></app-audit-trail-modal>
  <!-- TAX_ACCOUNTING_EDIT MODAL  -->
  <app-tax-accounting-edit></app-tax-accounting-edit>
  <!-- EXISTING_ISSUE_EDIT_MODAL -->
  @if (isIssueEditModalVisible) {
    <app-edit-existing-issue></app-edit-existing-issue>
  }

  <!-- TOAST COMPONENET: SUCCESS_FAILURE_MESSAGE -->
  <app-toast></app-toast>

  <footer class="np-footer">
    <ul>
      <li>&copy; {{ currentYear }} Chevron Corporation</li>
      <li>Company Confidential</li>
      <li>OpCo: <span>ITC</span></li>
    </ul>
    <ul>
      <li>Content contact: <span>Geralyn Quevedo</span></li>
      <li>Technical contact: <span>Global IT Service Desk</span></li>
    </ul>
  </footer>
}
